/* eslint-disable no-restricted-syntax */
export const EXTENSIONS = {
  PDF: 'pdf',
  JPG: 'jpg',
  JPEG: 'jpeg',
  PNG: 'png',
  WEBP: 'webp',
  GIF: 'gif',
  BMP: 'bmp',
  CSV: 'csv',
  XLSX: 'xlsx',
  WORD: ['docx', 'doc'] as const,
  EXCEL: ['xlsx', 'xls'] as const,
  VIDEO: [
    'mp4',
    'avi',
    'mov',
    'mkv',
    'mpg',
    'mpeg',
    'wmv',
    'flv',
    'webm',
    '3gp',
    'm4v',
  ] as const,
  IMAGE: ['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp'] as const,
  MAP_IMAGE: ['webp', 'jpg', 'jpeg', 'png'] as const,
} as const;
